export enum HaulerStatusEnum {
    PRE_SIGN_UP_NO_COGNITO = 0,
    PRE_SIGN_UP_NO_PROVIDER = 1,
    ON_WAITING_LIST = 2,
    IN_HOUSE_REVIEW_SUBMITTED = 3,
    IN_HOUSE_REVIEW_STARTED = 4,
    INCOMPLETE_INFO = 5,
    LOST_NOT_QUALIFIED = 6,
    LOST_NOT_INTERESTED = 7,
    GO_TRASHY_APPROVED = 8,
    VENDOR_REVIEW_SUBMITTED = 9,
    VENDOR_REVIEW_RECEIVED = 10,
    VENDOR_APPROVED = 11,
    VENDOR_NOT_APPROVED = 12,
    ACTIVE = 13,
    SUSPENDED = 14,
    ACTIVE_INFO_CHANGED = 15
}



// WEBPACK FOOTER //
// ./src/types/enums/HaulerStatusEnum.ts